export default "__VITE_PUBLIC_ASSET__816330d0__"